import { scoreColor } from 'utility'
import { useClientConfigQuery } from 'types'
import { Score } from './Score'

interface IGlucoseScoreAvatarProps {
  glucoseScore: number
}

export const GlucoseScoreAvatar = ({ glucoseScore }: IGlucoseScoreAvatarProps) => {
  const { data: clientConfigResult } = useClientConfigQuery()

  const warning = clientConfigResult?.clientConfig.score.warning
  const danger = clientConfigResult?.clientConfig.score.danger
  const color = scoreColor(glucoseScore, danger, warning)

  return <Score glucoseScore={glucoseScore} color={color} />
}
